/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
// import SubLine from '../createLine';
import { Styles } from '../tableStyles';
import { ChineseFonts } from '../fonts/font';

// Displaying Docked Summary Table
function Table2(props) {
  const { system_summary, ventil_summary, serialNum, langualgeCheck, translateObject } = props;
  let { subSerialNum } = props;
  const hearder_val = ['EDI Unit ID']; // Static Header values ----> Kranthi
  const header_val2 = [];
  const multiple_steams = [];
  // pushing all steam numbers in  empty array ----> Kranthi
  system_summary['EDI Unit ID'].forEach(element => {
    header_val2.push(element);
  });
  // we are spliting steam data into multiple array with consisting of 6 steam in every single array ----> Kranthi
  while (header_val2.length > 0) {
    multiple_steams.push(hearder_val.concat(header_val2.splice(0, 5)));
  }
  // const C1Width = 195; // 2st Coloum Width ----> Kranthi
  // const C2Width = 50; // 2nd Coloum Width ----> Kranthi
  // const C3Width = 70; // 3rd Coloum Width ----> Kranthi
  // using this function we are handling values  ----> Kranthi
  const appendNumberText = (value) => {
    if (value === undefined) {
      return ' ';
    }
    if (Number.isNaN(Number(value))) { // checking values is number or not ----> Kranthi
      const split_Val = value.split(' '); // spliting all the value with space ----> Kranthi
      if (split_Val.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = Number(split_Val[0]).toFixed(2);
        const text_val = split_Val[1];
        return `${num_val} ${text_val}`; // combing text and value ----> Kranthi
      }
      return value;
    }
    return Number(value).toFixed(2);
  };
  //  Static Values of category and parmeters -->Kranthi
  const key_value = [
    {
      'key': 'Electrode Gas Generation',
      'subkey': [
        {
          'key': 'Electrode Gas Generation',
          'keyValue': 'Electrode Gas Generation'
        }, {
          'key': 'H2',
          'keyValue': 'H2'
        },
        {
          'key': 'Cl2',
          'keyValue': 'Cl2'
        },
        {
          'key': '-',
          'keyValue': '-'
        }
      ]
    },
    {
      'key': 'Blower/Ventilation Sizing for H2',
      'subkey': [
        {
          'key': 'Blower/Ventilation Sizing for H2',
          'keyValue': 'Blower/Ventilation Sizing for H2'
        }, {
          'key': 'Explosion limit of H2 in Air',
          'keyValue': 'Explosion limit of H2 in Air'
        },
        {
          'key': 'Design Safety Factor',
          'keyValue': 'Design Safety Factor'
        },
        {
          'key': 'Ventilation Blower/Fan',
          'keyValue': 'Ventilation Blower/Fan'
        },
        {
          'key': 'Size',
          'keyValue': 'Size'
        }
      ]
    },
    {
      'key': 'Blower/Ventilation Sizing for Cl2',
      'subkey': [
        {
          'key': 'Blower/Ventilation Sizing for Cl2',
          'keyValue': 'Blower/Ventilation Sizing for Cl2'
        },
        {
          'key': 'Explosion limit of Cl2 in Air',
          'keyValue': 'Exposure Limit of Cl2 in Air'
        },
        {
          'key': 'Design Safety Factor',
          'keyValue': 'Design Safety Factor'
        },
        {
          'key': 'Ventilation Blower/Fan',
          'keyValue': 'Ventilation Blower/Fan'
        },
        {
          'key': 'Size',
          'keyValue': 'Size'
        }
      ]
    }
  ];
  const Main_heading = ['0-3', '1-4']; // where we need sub heading boarder ---> Kranthi
  const sub_heading = ['1-2', '2-2']; // where we need Main heading boarder ---> Kranthi
  return (
    <View style={{ marginTop: 10 }}>
      {/* sub HEading of Stripper Summary ---> Kranthi */}
      <View style={[Styles.subHeader, { marginTop: 10 }]}>
        {/* <SubLine lineWidth='10px' lineHeight='12' /> */}
        {/* <Text style={{ marginTop: -4, paddingLeft: 15, color: '#0062A9' }}>&#95;&#95;</Text> */}
        <Text style={[{ paddingLeft: 0 }, langualgeCheck && { fontFamily: ChineseFonts }]}>{serialNum}.{subSerialNum++}</Text>
        <Text style={[{ paddingLeft: 5 }, langualgeCheck && { fontFamily: ChineseFonts }]}>{translateObject('Ventilation Sizing')}</Text>
      </View>
      {
        // Multiple tables accourding to steam numbers
        multiple_steams.map((values, ind) => {
          let cellWidth = 100 / (values.length + 1);
          cellWidth = 100 - Math.floor(cellWidth * 1.5);
          return (
            <View key={ind} break={ind > 1} style={[Styles.table, { marginTop: 10, width: '100%' }]}>
              <View style={Styles.tableRow}>
                <Text style={[Styles.tableCellTextHeader, langualgeCheck && { fontFamily: ChineseFonts }]} >{translateObject('Total Number of EDI Unit')} = {system_summary['EDI Unit ID'].length}</Text>
              </View>
              <View style={Styles.tableRow}>
                {values.map((val, i) => {
                  // calculating width for table column and column 1.
                  const C1Width = `${(100 / (values.length)) * 2}%`;
                  const Cwidth = `${(100 / (values.length))}%`;
                  // header row
                  return (
                    <View key={i} style={[
                      Styles.tableHeader, { width: Cwidth, borderTopRightRadius: 0 },
                      (i === 0 && { width: C1Width, paddingLeft: 10, alignItems: 'left' }),
                      i === values.length - 1 && { borderRightWidth: 0 },
                    ]}>
                      <Text style={[Styles.tableCellHeader, langualgeCheck && { fontFamily: ChineseFonts }]}>{translateObject(val)}</Text>
                    </View>);
                })}
              </View>
              {key_value.map((keys, k_i) => {
                return (
                  <View style={Styles.tableRow} key={k_i}>
                    <View>
                      <View style={Styles.tableColumn}>
                        {keys.subkey.map((subKey, i) => {
                          // looping key value of EDI Unit ID
                          return (
                            <View style={Styles.tableRow} key={i}>
                              <View style={[
                                Styles.tableRCText, { margin: '-1 0' },
                                (Main_heading.includes(`${k_i}-${i}`)) && { borderBottom: 2, borderBottomColor: '#818B8D' },
                                (sub_heading.includes(`${k_i}-${i}`)) && { borderBottom: 2, borderBottomColor: '#ACB5BE' },
                                { paddingLeft: 10, alignItems: 'left' }
                              ]}>
                                <Text style={[
                                  Styles.tableCell,
                                  { width: '90%', paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: system_summary['EDI Unit ID'].length === 1 ? '60%' : system_summary['EDI Unit ID'].length === 2 ? '68%' : '75%' },
                                  (i === 0 && Styles.tableCellsubHeader),
                                  langualgeCheck && { fontFamily: ChineseFonts },
                                ]}>{translateObject(subKey.keyValue)}</Text>
                              </View>
                              <View style={[
                                Styles.tableRCText, { margin: '-1 0' },
                                (Main_heading.includes(`${k_i}-${i}`)) && { borderBottom: 2, borderBottomColor: '#818B8D' },
                                (sub_heading.includes(`${k_i}-${i}`)) && { borderBottom: 2, borderBottomColor: '#ACB5BE' }
                              ]}>
                                <Text style={[Styles.tableCell, langualgeCheck && { fontFamily: ChineseFonts }]}>{translateObject(ventil_summary.units[keys.key][subKey.key])}</Text>
                              </View>
                              {values.slice(1).map((val, h_i) => {
                                // we are looping for multiple columns of Parameter values
                                return (
                                  <View key={h_i}
                                    style={[
                                      Styles.tableRCText, { margin: '-1 0' },
                                      (h_i === values.slice(1).length - 1) && { borderRightWidth: 0 },
                                      (Main_heading.includes(`${k_i}-${i}`)) && { borderBottom: 2, borderBottomColor: '#818B8D' },
                                      (sub_heading.includes(`${k_i}-${i}`)) && { borderBottom: 2, borderBottomColor: '#ACB5BE' }
                                    ]}>
                                    {(() => {
                                      // checking for No. of E-Cell EDI Stacks
                                      //   if(subKey.keyVal === 'No. of E-Cell EDI Stacks'){
                                      //     return (<Text style={Styles.tableCell}>{system_summary[val][subKey.key].toFixed(0)}</Text>);
                                      //   }
                                      return (
                                        <Text
                                          style={[Styles.tableCell, langualgeCheck && { fontFamily: ChineseFonts }]}>{translateObject(appendNumberText(ventil_summary[val][keys.key][subKey.key]))}</Text>
                                      );
                                    })()}
                                  </View>
                                );
                              })}
                            </View>
                          );
                        })}
                      </View>
                    </View>
                  </View>
                );
              })}
            </View>
          );
        })}
      <View style={{ paddingTop: 10 }}>
        <Text style={[Styles.tableCell, langualgeCheck && { fontFamily: ChineseFonts }]}>
          {translateObject('Electrode_stream_vented_hydrogen')}
        </Text>
      </View>
      <View>
        <Text style={[Styles.tableCell, langualgeCheck && { fontFamily: ChineseFonts }]}>
          {translateObject('hydrogen_oxygen_gas_edi')}
        </Text>
      </View>
    </View >
  );
}
export default Table2;